import { Link } from 'react-router-dom';
import { Smartphone, Monitor, Globe, AppWindow, ArrowUpRight, Braces } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import SectionHeading from '@/components/SectionHeading';
import { Stagger, StaggerItem, Reveal } from '@/components/Reveal';

const ICONS = [Smartphone, Smartphone, Globe, Monitor];

export default function AppsPlatforms() {
  const { t, isRTL } = useLanguage();
  const platforms = t('apps.platforms');
  const icons = [Smartphone, Smartphone, Globe, AppWindow];
  return (
    <section className="border-y border-brand-line bg-brand-alt/60 py-24" data-testid="apps-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading eyebrow="apps.eyebrow" title="apps.title" sub="apps.sub" align="center" />
        <Stagger className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" gap={0.08}>
          {platforms.map((p, i) => {
            const Icon = icons[i] || Monitor;
            return (
              <StaggerItem key={p.name}>
                <div className="card-hover flex h-full flex-col rounded-2xl border border-brand-line bg-white p-6" data-testid={`apps-card-${i}`}>
                  <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-blue/8 text-brand-blue border border-brand-blue/15">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 font-display text-lg font-bold text-brand-ink">{p.name}</h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-steel">{p.desc}</p>
                  <div className="mt-5 flex items-center justify-between">
                    <span className="rounded-full bg-brand-alt px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-brand-blue">{p.badge}</span>
                    <Link to={p.link || '/download'} data-testid={`apps-link-${i}`} className="inline-flex items-center gap-1 text-xs font-bold text-brand-blue">
                      {t('apps.cta')} <ArrowUpRight className={`h-3.5 w-3.5 ${isRTL ? 'rotate-[-90deg]' : ''}`} />
                    </Link>
                  </div>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>

        <Reveal delay={0.15}>
          <div className="mt-4 flex flex-col items-start justify-between gap-4 overflow-hidden rounded-2xl border border-brand-ink bg-brand-ink p-6 sm:flex-row sm:items-center sm:p-8" data-testid="apps-api-strip">
            <div className="flex items-start gap-4">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-white/10 text-brand-sky"><Braces className="h-5 w-5" /></span>
              <div>
                <h3 className="font-display text-lg font-bold text-white">{t('apps.apiTitle')}</h3>
                <p className="mt-1 text-sm text-brand-dim">{t('apps.apiDesc')}</p>
              </div>
            </div>
            <code className="rounded-lg border border-white/15 bg-black/40 px-4 py-2.5 font-mono text-xs text-brand-sky" dir="ltr">GET /api/v1/positions?fleet=erbil-hq</code>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
